import { Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { IEditFile } from "./EditDocumentInterfaces";
import "./css/EditFile.css"; // Import the CSS file

export default function EditFile({
  fileDefaultValue = "",
  linkType,
  clear,
  onChange,
  onError,
}: IEditFile) {
  const isURL = linkType === "Url";
  const [editablePart, setEditablePart] = useState("");
  const [extension, setExtension] = useState("");
  const [width, setWidth] = useState("50%");

  useEffect(() => {
    if (isURL) {
      setEditablePart(fileDefaultValue);
    } else {
      const dotIndex = fileDefaultValue.indexOf(".");
      if (dotIndex !== -1) {
        setEditablePart(fileDefaultValue.slice(0, dotIndex));
        setExtension(fileDefaultValue.slice(dotIndex + 1));
      } else {
        setEditablePart(fileDefaultValue);
        setExtension("");
      }
    }
    onChange(fileDefaultValue);
  }, [clear, fileDefaultValue, isURL]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (!isURL && /[./\\:?*"<>|]/.test(newValue)) {
      onError(
        'Filename cannot contain any of the following characters: . / \\ : ? * " < > |'
      );
      return;
    }
    setEditablePart(newValue);

    const updatedFile = isURL
      ? newValue
      : `${newValue}${extension ? "." + extension : ""}`;
    onChange(updatedFile);
  };

  const calculateWidth = (length: number) => {
    return Math.max(50, Math.min(100, length * 0.8));
  };

  useEffect(() => {
    const newWidth = `${calculateWidth(fileDefaultValue.length)}%`;
    setWidth(newWidth);
  }, [fileDefaultValue]);

  useEffect(() => {
    const newWidth = `${calculateWidth(editablePart.length)}%`;
    setWidth(newWidth);
  }, [editablePart]);

  return (
    <Row>
      <Col xs={2}>
        <label>{isURL ? "Url" : "Filename"}</label>
      </Col>
      <Col>
        <div className="input-group" style={{ width }}>
          <input
            value={editablePart}
            onChange={handleChange}
            placeholder="Edit File"
            className="form-control"
          />
          {!isURL && extension && (
            <span className="input-group-text fixed-span">.{extension}</span>
          )}
        </div>
      </Col>
    </Row>
  );
}
